import voiceImg from '@/assets/measure_voice.png'
import lightImg from '@/assets/measure_light.png'
import waterImg from '@/assets/measure_water.png'
import airImg from '@/assets/measure_air.png'

export const typeKeyEnum = {
  VOICE: {
    key: 'VOICE',
    title: '声音检测',
    dataKey: 'soundDetection',
    exampleImg: voiceImg,
    formConfig: [
      {label: 'id', name: 'id', hidden: true},
      // {label: '区域', name: 'area', type: 'select'},
      {label: '区域', name: 'areaName', comConfig: {maxLength: 20, showCount: true}},
      {label: '值', name: 'value', type: 'select'},
      {name: 'valueName', hidden: true},
    ]
  },
  LIGHT: {
    key: 'LIGHT',
    title: '光照检测',
    dataKey: 'lightDetection',
    exampleImg: lightImg,
    formConfig: [
      {label: 'id', name: 'id', hidden: true},
      // {label: '区域', name: 'area', type: 'select'},
      {label: '区域', name: 'areaName', comConfig: {maxLength: 20, showCount: true}},
      {label: '值', name: 'value', type: 'select'},
      {name: 'valueName', hidden: true},
    ]
  },
  WATER: {
    key: 'WATER',
    title: '水质检测',
    dataKey: 'waterQualityDetection',
    exampleImg: waterImg,
    formConfig: [
      {label: 'id', name: 'id', hidden: true},
      {label: '区域', name: 'areaName', comConfig: {maxLength: 20, showCount: true}},
      {label: '1L中含有可溶性物质㎎标准', name: 'soluble', type: 'select'},
      {name: 'solubleName', hidden: true},
      {label: 'PH值', name: 'ph', type: 'inputNumber'},
      {label: 'EC值', name: 'ec', type: 'select'},
      {name: 'ecName', hidden: true},
    ]
  },
  AIR: {
    key: 'AIR',
    title: '空气检测',
    dataKey: 'airDetection',
    exampleImg: airImg,
    formConfig: [
      {label: 'id', name: 'id', hidden: true},
      {label: '区域', name: 'areaName', comConfig: {maxLength: 20, showCount: true}},
      {label: '甲醛浓度', name: 'jqnd'},
      {label: 'TVOC含量', name: 'tvoc'},
      {label: '温度', name: 'temperature'},
      {label: '湿度', name: 'humidity'},
      {label: 'PM2.5', name: 'pm25', type: 'select'},
      {name: 'pm25Name', hidden: true},
    ]
  },
}
